import React from 'react';
import PropTypes from 'prop-types';
import AppContainer from 'components/AppContainer';
import { withStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import ListTitle from 'components/ListTitle';

const styles = () => ({
  container: {
    // borderBottom: '1px solid #aaa',
    // borderTop: '1px solid #aaa',
    backgroundColor: 'rgba(0, 0, 0, 0.025) !important',
  },
  root: {
    paddingTop: 12,
    paddingBottom: 12,
  },
  headerTitle: {
    display: 'flex',
    alignItems: 'center',
  },
  subtitle: {
    fontSize: '1.05rem',
  },
});

function Header({ classes, title }) {
  return (
    <div className={classes.container}>
      <AppContainer>
        <Grid container>
          <Grid item xs={12} className={classes.root}>
            <ListTitle title={title} isMain />
          </Grid>
        </Grid>
      </AppContainer>
    </div>
  );
}

Header.propTypes = {
  classes: PropTypes.object,
  title: PropTypes.string,
};

export default withStyles(styles)(Header);
